import createSavedSearch$ from './apis/create';
import ResultCategoryType from './enums/resultCategoryType';

require('./components/savedSearchHandler');

export { ResultCategoryType, createSavedSearch$ };